import { defineStore } from 'pinia'
import { ref } from 'vue'
import { defaultThemeColor, defaultTextColor } from 'javascript/Constants'

export const useColorsStore = defineStore('Colors', () => {
  const textColor = ref('')
  const themeColor = ref('')

  function setThemeAndTextColor(payload) {
    themeColor.value = payload.themeColor || defaultThemeColor
    textColor.value = payload.textColor || defaultTextColor
  }

  return {
    textColor,
    themeColor,

    setThemeAndTextColor
  }
})
